module.exports = __webpack_public_path__ + "static/media/img-ganhadores.06ea4624.jpg";